import { Box, Heading } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonMultiSelectInput } from 'components/common/form/multiselect';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IOption } from 'lib_ts/interfaces/common/i-option';
import { useState } from 'react';

const DEMO_OPTIONS: IOption[] = [
  {
    label: 'Food',
    value: 'foodID',
    group: 'Food',
    isGroup: true,
    disabled: true,
    hideControl: true,
  },
  { label: 'Apple', value: 'appleID', group: 'Food' },
  { label: 'Banana', value: 'bananaID', group: 'Food' },
  { label: 'Orange', value: 'orangeID', group: 'Food' },
  { label: 'Carrot', value: 'carrotID', group: 'Food' },
  { label: 'Broccoli', value: 'broccoliID', group: 'Food' },
  { label: 'Spinach', value: 'spinachID', group: 'Food' },
  {
    label: 'Colors',
    value: 'colorsID',
    group: 'Design',
    isGroup: true,
    disabled: true,
    hideControl: true,
  },
  { label: 'Red', value: 'redID', group: 'Design' },
  { label: 'Blue', value: 'blueID', group: 'Design' },
  { label: 'Green', value: 'greenID', group: 'Design' },
];

export const FeatureDemoMultiSelect = () => {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  return (
    <ErrorBoundary identifier="FeatureDemoMultiSelect">
      <CommonMultiSelectInput
        id="demo-multiselect"
        label="Select Items"
        placeholder="Search items..."
        options={DEMO_OPTIONS}
        values={selectedValues}
        onChange={setSelectedValues}
        onSearch={(term) => console.log('Searching:', term)}
      />

      <Box>
        <Heading size={RADIX.HEADING.SIZE.SM}>Selected Values:</Heading>
        <pre>{JSON.stringify(selectedValues, null, 2)}</pre>
      </Box>
    </ErrorBoundary>
  );
};
